


















export default {
  props: ['requirement', 'active'],
};

